export default "__VITE_ASSET__43d665a4__"